/** "vor 12 s", "vor 3 min", "vor 2 h" – ms Alter -> Text. */
export function formatAge(ms: number | null): string {
  if (ms === null) return 'noch keine Antwort'
  const s = Math.max(0, Math.round(ms / 1000))
  if (s < 5) return 'gerade eben'
  if (s < 60) return `vor ${s} s`
  const m = Math.floor(s / 60)
  if (m < 60) return `vor ${m} min`
  const h = Math.floor(m / 60)
  if (h < 48) return `vor ${h} h`
  return `vor ${Math.floor(h / 24)} Tagen`
}

export function formatClock(ts: number | null): string {
  if (ts === null) return '–'
  return new Date(ts).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
}
